import certification from "./certification"
import client from "./client"
import course from "./course"
import discount from "./discount"
import instructor from "./instructor"
import lab from "./lab"
import learningCue from "./learningCue"
import lesson from "./lesson"
import path from "./path"
import user from "./user"
import video from "./video"
import waitlist from "./waitlist"
export default {
  certification,
  client,
  course,
  discount,
  instructor,
  lab,
  learningCue,
  lesson,
  path,
  user,
  video,
  waitlist,
}
